import { render } from "./DashboardSpaceTimeSeriesGraph.vue?vue&type=template&id=3837d91e&scoped=true"
import script from "./DashboardSpaceTimeSeriesGraph.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceTimeSeriesGraph.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3837d91e"

export default script